import React, { useState, useEffect} from 'react';
import campfireImage from '../assets/campfire.png';
import Footer from "../components/Footer.jsx";
import './journeybuttons.css'
import './campfirepage.css';
import LogoutButton from '../components/logout2.jsx';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Crystal from '../components/crystal.jsx';
import subTopics, { nameMap } from './subtopics.jsx';
import api from '../api.js'

import scrollImage from '../assets/croppedscroll.png'; // adjust path as needed



function CampfirePage() {
  const topMargin = '5vh';
  const bottomMargin = '7vh';
  const sideMargin = '10vw';
  const [showJourneyOverlay, setShowJourneyOverlay] = useState(false);
  const navigate = useNavigate();
  const [showAchievements, setShowAchievements] = useState(false);
  const [progress, setProgress] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // 26th
  const [displayName, setDisplayName] = useState('');

  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [leaderboard, setLeaderboard] = useState([]);
  const [yourRank, setYourRank] = useState(null);
  const [yourPercent, setYourPercent] = useState(null);
  const [isLoadingLeaderboard, setIsLoadingLeaderboard] = useState(false);


useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
//`${process.env.REACT_APP_API_URL}/api/login/`


  useEffect(() => {
    async function fetchProgress() {
      try {
        //const { data } = await axios.get(
        const { data } = await api.get(
          `${process.env.REACT_APP_API_URL}/api/progress/nested/`
        );
        setProgress(data);
      } catch (err) {
        console.error('Failed to fetch batch progress:', err);
      }
    }
    fetchProgress();
  }, []);

  useEffect(() => {
    async function fetchMe() {
      try {
        //const { data } = await axios.get(
        const { data } = await api.get(
          `${process.env.REACT_APP_API_URL}/api/me/`
        );
        setDisplayName(data.display_name);
      } catch (err) {
        console.error('Failed to fetch display name:', err);
      }
    }
    fetchMe();
  }, []);

  const renderCrystals = (percent) => {
    const thresholds = [33.33, 66.66, 99.99];
    return thresholds.map((t, idx) => (
      <Crystal key={idx} size={24} locked={percent < t} />
    ));
  };

  return (
    <div
      style={{
        backgroundColor: '#000',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'sans-serif',
        color: 'white',
      }}
    >
      {/* Top Bar */}
<div className='campfire-topbar medieval-text'>
  {displayName && `Welcome, ${displayName}!`}
</div>


      {/* Main Image Area */}
<div className="campfire-container">
  <img src={campfireImage} alt="Campfire background" className="campfire-background" />
<div/>
        {!showJourneyOverlay && (
          <>
            {/* Interactive Text */}






<div className="achievements-box" onClick={() => setShowAchievements(true)}>
  <div className="achievements-title medieval-text">🏆</div>
  <div className="crystal-row">
    <img src={require('../assets/crystal.png')} alt="Crystal" className="achievements-crystal" />
    <img src={require('../assets/crystal.png')} alt="Crystal" className="achievements-crystal" />
    <img src={require('../assets/crystal.png')} alt="Crystal" className="achievements-crystal" />
  </div>
</div>





<div className="start-journey-button" onClick={() => setShowJourneyOverlay(true)}>
  Start Journey
</div>


            <button
              className="rank-button medieval-text"
              onClick={async () => {
                setIsLoadingLeaderboard(true);
                setShowLeaderboard(true);
                try {
                  //const { data } = await axios.get(
                  const { data } = await api.get(
                    `${process.env.REACT_APP_API_URL}/api/leaderboard/`
                  );
                  setLeaderboard(data.leaderboard);
                  setYourRank(data.your_rank);
                  setYourPercent(data.your_percent);
                } catch {
                  setLeaderboard([]);
                  setYourRank(null);
                  setYourPercent(null);
                } finally {
                  setIsLoadingLeaderboard(false);
                }
              }}
            >
              My Rank
            </button>





            {/* Sparks */}
{[...Array(15)].map((_, i) => {
const bottomRange = isMobile ? [35, 40] : [25, 35];  // 👈 Sparks lower on screen for mobile
  const leftRange = isMobile ? [60, 70] : [41, 51];    // 👈 Sparks shifted to the right for mobile


  const randomBottom = bottomRange[0] + Math.random() * (bottomRange[1] - bottomRange[0]);
  const randomLeft = leftRange[0] + Math.random() * (leftRange[1] - leftRange[0]);

  return (
    <div
      key={i}
      className="spark"
      style={{
        bottom: `${randomBottom}%`,
        left: `${randomLeft}%`,
        animationDuration: `${3 + Math.random() * 2}s`,
        animationDelay: `${Math.random()}s`,
      }}
    />
  );
})}

          </>
        )}

        {showJourneyOverlay && (
          <div className="journey-overlay">
            <img src={require('../assets/journeyMap.png')} alt="Journey Map" className="journey-map-image" />

            
            <div className="journey-button-wrapper exit-button">
              <button className="journey-button" onClick={() => setShowJourneyOverlay(false)}>Exit</button>
            </div>

            <div className="journey-button-wrapper history-button">
              <button className="journey-button" onClick={() => navigate('/history2')}>History</button>
            </div>
            
            <div className="journey-button-wrapper politics-button">
              <button className="journey-button">Politics 🔒</button>
            </div>

            <div className="journey-button-wrapper psychology-button">
              <button className="journey-button">Psychology 🔒</button>
            </div>

            <div className="journey-button-wrapper philosophy-button">
              <button className="journey-button">Philosophy 🔒</button>
            </div>




          </div>

          
        )}
        
      </div>

<div className="logout-button-position">
  <LogoutButton />
</div>

{showAchievements && (
  <div style={{
    position: 'absolute',
    top: '10%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '80vw',
    maxWidth: '600px',
    maxHeight: '70vh',        // 👈 Limit height
    overflowY: 'auto',        // 👈 Enable vertical scroll
    backgroundColor: '#222',
    border: '2px solid gold',
    borderRadius: '8px',
    padding: '1rem',
    zIndex: 100,
    color: 'white'
  }}>
    <h2 className="medieval-text" style={{ textAlign: 'center', color: '#f9d88a' }}>🏆 Your Achievements</h2>

{Object.entries(progress).map(([subject, topics]) => (
  <div key={subject} style={{ marginBottom: '1.5rem' }}>
    <h3 className="medieval-text" style={{ color: '#f9d88a' }}>
        {nameMap[subject] || subject}
    </h3>

    {Object.entries(topics).map(([topic, subtopics]) => (
      <div key={topic} style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
        <h4 className="medieval-text" style={{ color: '#ccc' }}>
            {nameMap[topic] || topic}
        </h4>

        {Object.entries(subtopics).map(([subtopicName, percent]) => (
          <div key={subtopicName} style={{ margin: '0.5rem 0', marginLeft: '1rem' }}>
          <div style={{ fontSize: '1.1rem', marginBottom: '0.25rem' }}>
            {nameMap[subtopicName] || subtopicName}
          </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              {renderCrystals(percent)}
              <span style={{ marginLeft: 'auto' }}>{percent}%</span>
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
))}



    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
      <button className="journey-button" onClick={() => setShowAchievements(false)}>Close</button>
    </div>
  </div>
)}

{showLeaderboard && (
  <div className="leaderboard-overlay">
    <div className="leaderboard-scroll-bg">
      <img src={scrollImage} alt="Scroll" className="scroll-img" />
      <div className="leaderboard-content">
      <div className="close-btn-container">
        <button className="close-btn medieval-text" onClick={() => setShowLeaderboard(false)}>
          Close
        </button>
      </div>
        <h2 className="medieval-text leaderboard-title">🏆 Leaderboard</h2>
        {isLoadingLeaderboard ? (
          <div className="leaderboard-loading">Loading...</div>
        ) : (
          <>
            {yourRank !== null && (
              <div className="your-rank">
                <b>Your Rank:</b> {yourRank} &nbsp;&nbsp;
                <b>Your Completion:</b> {yourPercent}%
              </div>
            )}
            <div className="leaderboard-list">
              {leaderboard.map((entry, idx) => (
                <div
                  className={`leaderboard-row${entry.user_id === window.currentUserId ? ' you' : ''}`}
                  key={entry.user_id}
                >
                  <span className={`medieval-text leaderboard-name${entry.user_id === window.currentUserId ? ' bold' : ''}`}>
                    {idx + 1}. {entry.display_name}
                  </span>
                  <span className="leaderboard-percent">{entry.percent}%</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)}




      {/* Bottom Bar */}
      <div
        style={{
          height: bottomMargin,
          backgroundColor: '#111',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '1.2rem',
        }}
      >
        
      </div>
    </div>
  );
}

export default CampfirePage;
